<template>
  <swiper
    class="swiper-responsive-breakpoints"
    :options="swiperOptions"
    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
  >
    <swiper-slide v-for="(data, index) in swiperData" :key="index">
      <b-img :src="data.img" fluid />
    </swiper-slide>

    <div slot="pagination" class="swiper-pagination" />
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { BImg } from "bootstrap-vue";
import "swiper/css/swiper.css";

export default {
  components: {
    Swiper,
    SwiperSlide,
    BImg,
  },
  props: {
    swiperData: {
      type: Array,
    },
  },
  data() {
    return {
      /* eslint-disable global-require */
      // swiperData: [
      //   { img: require("@/assets/images/banner/banner-30.jpg") },
      //   { img: require("@/assets/images/banner/banner-31.jpg") },
      //   { img: require("@/assets/images/banner/banner-32.jpg") },
      //   { img: require("@/assets/images/banner/banner-33.jpg") },
      //   { img: require("@/assets/images/banner/banner-34.jpg") },
      //   { img: require("@/assets/images/banner/banner-35.jpg") },
      //   { img: require("@/assets/images/banner/banner-36.jpg") },
      //   { img: require("@/assets/images/banner/banner-37.jpg") },
      //   { img: require("@/assets/images/banner/banner-38.jpg") },
      // ],
      /* eslint-disable global-require */

      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 50,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
      },
    };
  },
};
</script>
